import { useState } from "react";
import { Link } from "react-router-dom";
import { api, parseErrorDetail } from "../lib/api";

// The exact wording of the generic confirmation is owner-mandated (R20 §2).
const GENERIC_CONFIRMATION =
  "If an account matches those details, a password reset email has been sent.";

export default function ForgotPasswordPage() {
  const [username, setUsername] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      // Fire-and-forget from the browser's perspective — the server always
      // returns the SAME generic message + status regardless of account
      // existence. We do NOT branch on the response.
      await api.post("/auth/password-reset/request", { username: username.trim() });
    } catch (_) {
      // Even if the server returns non-2xx (unlikely for this endpoint), we
      // still show the generic confirmation so no oracle is exposed.
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="apwo-auth-shell">
      <div className="apwo-auth-container">
        <div className="apwo-auth-card" role="dialog" aria-labelledby="apwo-fp-title" data-testid="forgot-card">
          <header className="apwo-auth-header">
            <p className="apwo-brand-eyebrow">AUTOPARTSB2B</p>
            <h1 id="apwo-fp-title" className="apwo-auth-title" data-testid="forgot-title">Reset your password</h1>
            <p className="apwo-auth-sub">
              Enter the username you use to sign in. If it matches an active AP Warehouse account,
              we&rsquo;ll email a single-use reset link to the address on file.
            </p>
          </header>

          {submitted ? (
            <div className="apwo-alert-success" role="status" data-testid="forgot-generic-confirmation">
              {GENERIC_CONFIRMATION}
            </div>
          ) : (
            <form className="apwo-auth-form" onSubmit={onSubmit} noValidate data-testid="forgot-form">
              <label className="apwo-field">
                <span>Username</span>
                <input
                  type="text"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  data-testid="forgot-username"
                  autoCapitalize="none"
                  autoCorrect="off"
                />
              </label>
              <button
                type="submit"
                className="apwo-btn-primary"
                disabled={submitting || !username}
                data-testid="forgot-submit"
              >
                {submitting ? "Sending…" : "Send reset email"}
              </button>
            </form>
          )}

          <footer className="apwo-auth-footer">
            <p className="apwo-support-line">
              <Link to="/login" data-testid="forgot-back-to-login">Back to sign in</Link>
            </p>
            <p className="apwo-fineprint">
              Still stuck? Contact AUTOPARTSB2B on
              {" "}<a href="tel:+61426266655">0426 266 655</a>{" "}
              or <a href="mailto:order@autopartsb2b.com.au">order@autopartsb2b.com.au</a>.
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
}
